
import { Message } from 'element-ui';
import cryptoJs from './crypto-js';

var key = cryptoJs.enc.Utf8.parse('WXZhidaCX_V1.0.0'); // 密钥
var iv = cryptoJs.enc.Utf8.parse('20180101Abcdefg!'); // 密钥偏移量

let utils = {};

/**
	 * AES加密 ：字符串 key iv  返回base64
	 * 把默认的KEY 与 iv赋值给变量
	 * 如果有keyStr 重新赋值密钥
	 * 重新设置密钥偏移量
	 */
utils.encrypted = function(word) {
	const srcs = cryptoJs.enc.Utf8.parse(word);
	const encrypted = cryptoJs.AES.encrypt(srcs, key, {
	  iv, // 偏移量
	  mode: cryptoJs.mode.CBC,
	  padding: cryptoJs.pad.Pkcs7
	});
	// return cryptoJs.enc.Base64.stringify(encrypted.ciphertext);
	return encrypted.ciphertext.toString(cryptoJs.enc.Base64)
}
	
// 解密
utils.decrypted = function(word) {
	const encryptedHexStr = cryptoJs.enc.Hex.parse(word);
	const src = cryptoJs.enc.Base64.stringify(encryptedHexStr);
	const decrypted = cryptoJs.AES.decrypt(src, key, {
    iv, // 偏移量
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
	});
	 
	const decryptedStr = decrypted.toString(cryptoJs.enc.Utf8);
	return decryptedStr.toString();
}

// 成功提示
utils.success = function (msg = '成功') {
    Message.success({
        message: msg,
        customClass: 'zd-el-message'
    });
};

// 成功提示
utils.error = function (msg = '失败') {
    Message.error({
        message: msg,
        customClass: 'zd-el-message'
    });
};

// 非空判断
utils.notEmpty = function (o) {
    if (o == undefined || o == '' || o == null) {
        return false;
    }
    return true;
};
utils.isEmpty = function (o) {
    if (o == undefined || o == '' || o == null) {
        return true;
    }
    return false;
};

// 页面加载
let pageLoading = null;
utils.showLoading = function (vm) {
    pageLoading = vm.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255,255, 0.9)'
    });
};

// 结束加载
utils.hideLoading = function (vm) {
    if(pageLoading){
        pageLoading.close();
        pageLoading = null;
    }
   
};

// 文件
utils.saveExcelFile = function (data) {
    var fileName = data.fileName;
    // 判断空
    if (utils.isEmpty(fileName)) return;

    var bin = atob(data.base64.replace(/\s/g, ''));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }

    var blob = new Blob([buffer.buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 输出文件
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.target = '_blank';
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
    }
};

// 下载上传的文件
utils.exportUploadFile = function (file) {
    function dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    function downloadFile(url, name) {
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", name)
        a.setAttribute("target", "_blank")
        let clickEvent = document.createEvent("MouseEvents");
        clickEvent.initEvent("click", true, true);
        a.dispatchEvent(clickEvent);
    }

    function downloadFileByBase64(base64, name) {
        var myBlob = dataURLtoBlob(base64)
        var myUrl = URL.createObjectURL(myBlob)
        downloadFile(myUrl, name)
    }

    var reader = new FileReader(); //本地预览
    reader.readAsDataURL(file); //Base64  
    reader.onload = function () {
        var resData = reader.result;
        downloadFileByBase64(resData, file.name)
    }
}

// 判断对象非空
utils.notNull = function (obj) {
  if (obj !== '' && obj !== ' ' && obj !== undefined && obj !== null) {
      return true;
  }
  return false;
};

// 排序参数
utils.compare = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    };
};
utils.compareAsc = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
    };
};

// 获取配置项
utils.getConfigByType = function (vm, types, callback) {
    var url = vm.$A.configType + '/' + types+'/'+vm.$C.corpNo;
    vm.$H.get(vm,url, {}).then(res => {
        var rtList = res.data.data,rtObj = {};
        rtList.forEach(obj => {
            rtObj[obj.type] = obj.list;
        });
        callback(rtObj);
    });
};

// 字符串包含
utils.isContains = function (str, substr) {
  return str.indexOf(substr) >= 0;
}

// 图片按类别排布
utils.picArrange = list =>{
    let attachTypesObj = {};
      for (let v of list) {
        if (attachTypesObj[v.attachType] == undefined) {
          attachTypesObj[v.attachType] = [];
        }
        attachTypesObj[v.attachType].push(v);
      }
      return attachTypesObj;
}

  // 详情页面刷新后通过矩阵判断跳转页面
utils.pageJump = (vm,stepMatrix,isLeader,status)=>{
    let routeName = "";
    switch (stepMatrix) {
        case "0,1,0,0,0,0,0,0,0,0,0":
          routeName = "surveyDetail1";
          break;
        case "0,0,1,0,0,0,0,0,0,0,0":
          routeName = "surveyDetail2";
          break;
        case "0,0,0,1,0,0,0,0,0,0,0":
          routeName = "surveyDetail3";
          break;
        case "0,0,0,0,1,0,0,0,0,0,0":
          routeName = "surveyDetail4";
          break;
        case "0,0,0,0,0,1,0,0,0,0,0":
          routeName = "surveyDetail5";
          break;
        case "0,0,0,0,0,0,1,0,0,0,0":
          routeName = "surveyDetail6";
          break;
        case "1,1,0,0,0,0,0,0,0,0,0":
          routeName = "installDetail2";
          break;
        case "1,0,1,0,0,0,0,0,0,0,0":
          routeName = "installDetail3";
          break;
        case "1,0,0,1,0,0,0,0,0,0,0":
          routeName = "installDetail4";
          break;
        case "1,0,0,0,1,0,0,0,0,0,0":
          routeName = "installDetail5";
          break;
        case "1,0,0,0,0,1,0,0,0,0,0":
          routeName = "installDetail6";
          break;
        case "1,0,0,0,0,0,1,0,0,0,0":
          routeName = "review";
          break;
        case "2,0,0,1,0,0,0,0,0,0,0":
          routeName = "firstInstance";
          break;
        case "2,0,0,0,1,0,0,0,0,0,0":
          routeName = "secondInstance";
          break;
        case "2,0,0,0,0,1,0,0,0,0,0":
          routeName = "qualityAudit";
          break;
        case "2,0,0,0,0,0,0,1,0,0,0":
          routeName = "orderAudit";
          break;
        case "2,1,0,0,0,0,0,0,0,0,0":
          routeName = "orderAudit";
          break;
        case "2,0,1,0,0,0,0,0,0,0,0":
          routeName = "orderFinish";
          break;
        case "3,0,1,0,0,0,0,0,0,0,0":
          routeName = "unusualInstall";
          break;
        case "3,1,0,0,0,0,0,0,0,0,0":
          routeName = "unusualInspect";
          break;
        case "4,0,1,0,0,0,0,0,0,0,0":
          routeName = "invalidInstall";
          break;
        case "4,1,0,0,0,0,0,0,0,0,0":
          routeName = "invalidInspect";
          break;
        case "5,0,1,0,0,0,0,0,0,0,0":
          routeName = "stopAudit1";
          break;
        case "5,0,0,1,0,0,0,0,0,0,0":
          routeName = "stopAudit2";
          break;
      }
      vm.$router.push({
        name: routeName
      });
};

export default utils; 